<template>

  <!-- Completed (CANCELED) -->
  <route-list-data-table
      title="Canceled"
      defaultSortField="canceled_at"
      defaultSortOrder="dsc"
      :headers="headers"
      :status="status"
      :assocs="assocs"
      routeClickGoTo="route-info" />

</template>

<script>
import RouteListDataTable from '@/components/routes/RouteListDataTable'

export default {
  name: 'RouteListCanceledPage',

  components: {
    RouteListDataTable
  },

  data () {
    return {
      headers: [
        { text: 'Name', align: 'start', value: 'name', width: '18%' },
        { text: 'Orders', sortable: false, value: 'orders', width: '180px' },
        { text: 'Vehicle', value: 'vehicle_id' },
        { text: 'Driver', value: 'driver_user_id' },
        { text: 'Canceled', value: 'canceled_at' },
        { text: 'Status', align: 'start', value: 'route_status' }
      ],
      status: ['CANCELED'],
      assocs: 'orders,driver,vehicle'
    }
  }
}
</script>

<style scoped>
</style>
